import { useOpenModal } from '@/hooks/general/useOpenModal';
import { lazy } from 'react';
import MixpanelService from '@/utils/mixpanel.service';

const Modal = lazy(() => import('@/features/Claim/modals/SelectTypeModal'));

export const useShowTypeModal = () => {
  const openModal = useOpenModal();

  const showTypeModal = (easyshipShipmentId: string) => {
    MixpanelService.track('Shipment Details - Insurance - Show Insurance Claim Flow', {
      easyship_shipment_id: easyshipShipmentId,
    });
    return openModal(Modal, { shipmentId: easyshipShipmentId });
  };

  return {
    showTypeModal,
  };
};
